module.exports = __webpack_public_path__ + "static/media/bibles-logo-white.3d9ccba0.svg";